import { useState, useCallback, useRef } from 'react';
import { Icon, Tooltip } from '@web-chat-core/ui-kit';
import type { MenuItem } from '../ControlButtonMenu/ControlButtonMenu';
import { LabelItem, LabelWrapper, Label } from './view';

interface LabelRowProps {
    item: MenuItem;
    onSelect: (item: MenuItem) => void;
}

export const LabelRow = ({ item, onSelect }: LabelRowProps) => {
    const [isShowTooltip, setIsShowTooltip] = useState(false);
    const labelTextRef = useRef<HTMLSpanElement | null>(null);

    const handleShowTooltip = useCallback(() => {
        const el = labelTextRef.current;
        if (!el) return;
        setIsShowTooltip(el.scrollHeight > el.clientHeight);
    }, []);

    const handleHideTooltip = useCallback(() => {
        setIsShowTooltip(false);
    }, []);

    return (
        <Tooltip show={isShowTooltip} label={item.text} position="left" disableHoverableContent={true}>
            <LabelItem
                onSelect={(e) => {
                    e.preventDefault();
                    onSelect(item);
                }}
                onMouseEnter={handleShowTooltip}
                onMouseLeave={handleHideTooltip}
                onFocus={handleShowTooltip}
                onBlur={handleHideTooltip}
            >
                <Icon icon="icReadSent" colorVariant={item.active ? 'basic' : 'transparent'} />
                <LabelWrapper variant="body3">
                    <Label ref={labelTextRef}>{item.text}</Label>
                </LabelWrapper>
            </LabelItem>
        </Tooltip>
    );
};

LabelRow.displayName = 'LabelRow';
